// @flow

import React from 'react';
import ShowAt from 'react-aaui/lib/viewport/ShowAt';

import viewports from './viewport';

const ResultsShowAt = (props: Object) => (
  <ShowAt {...props} viewports={viewports} />
);

export default ResultsShowAt;
